export const footer = {
  newsletter: {
    label: "S'abonner à la newsletter",
    inputLabels: {
      email: "Adresse e-mail",
      next: "Suivant",
      salutation: "Titre",
      firstname: "Prénom",
      lastname: "Nom de famille",
      company: "Entreprise",
      address: "Adresse",
      postalCode: "Code postal",
      city: "Ville",
      privacyStatement: "Déclaration de confidentialité",
      privacyStatementCheckbox:
        "J'accepte que Maagtechnic AG traite mes données personnelles afin de répondre à ma demande. ",
      send: "Envoyer",
    },
    requiredFieldsMissing: "Certains champs obligatoires sont manquants",
  },
  socialMedia: {
    label: "Suivez-nous sur",
  },
  legal: {
    label: "Juridique",
    links: {
      termsAndConditions: {
        link:
          "https://maagtechnic.ch/content/dam/ch/pdf/unternehmen/rechtliches/Maagtechnic%20AGB_EN.pdf",
        text: "General Terms and Conditions of Sale",
      },
      imprint: {
        link: "https://maagtechnic.ch/fr/sur-nous/mentions-legales/",
        text: "Mentions légales",
      },
      disclaimer: {
        link: "https://maagtechnic.ch/fr/sur-nous/clause-de-non-respnsabilite/",
        text: "Clause de non-responsabilité",
      },
      privacy: {
        link: "https://maagtechnic.ch/fr/privacy/",
        text: "Déclaration de respect de la vie privée",
      },
    },
  },
};
